import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import PurchaseOrderModule from './PurchaseOrderModule.vue'
import ListPurchaseOrders from './views/ListPurchaseOrders.vue'
import CreatePurchaseOrder from './views/CreatePurchaseOrder.vue'
import ShowPurchaseOrder from './views/ShowPurchaseOrder.vue'
import EditPurchaseOrder from './views/EditPurchaseOrder.vue'
import ViewPurchaseOrder from './views/ViewPurchaseOrder.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/purchaseOrders',
    component: PurchaseOrderModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: '',
        name: 'ListPurchaseOrders',
        component: ListPurchaseOrders,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'new',
        name: 'CreatePurchaseOrder',
        component: CreatePurchaseOrder,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id',
        name: 'ShowPurchaseOrder',
        component: ShowPurchaseOrder,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'edit/:id',
        name: 'EditPurchaseOrder',
        component: EditPurchaseOrder,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  },
  {
    path: '/purchaseOrder/:id',
    name: 'ViewPurchaseOrder',
    component: ViewPurchaseOrder
  }
]

export default routes
